var exports = {
  "WD": "x4ddf2309--134578--labels",
  "Pf": "x4ddf2309--134578--label",
  "Kk": "x4ddf2309--134578--icon",
};

module.exports = exports;
